import { render, staticRenderFns } from "./treatmentpartsalequantity.vue?vue&type=template&id=6a93fc0f&scoped=true"
import script from "./treatmentpartsalequantity.vue?vue&type=script&lang=js"
export * from "./treatmentpartsalequantity.vue?vue&type=script&lang=js"
import style0 from "./treatmentpartsalequantity.vue?vue&type=style&index=0&id=6a93fc0f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93fc0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a93fc0f')) {
      api.createRecord('6a93fc0f', component.options)
    } else {
      api.reload('6a93fc0f', component.options)
    }
    module.hot.accept("./treatmentpartsalequantity.vue?vue&type=template&id=6a93fc0f&scoped=true", function () {
      api.rerender('6a93fc0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sale/treatmentpartsalequantity.vue"
export default component.exports